import { Path, Transforms } from 'slate'

import { CustomEditor } from 'core-components/library/richTextEditor/interface/custom-types'

import { createCell, getCol, getGridTable, isTable, TableCol } from './commonTableHelper'
import { getInsertPositionCol } from './getInsertPositionHelper'

export const checkInsertRight = (gridTable: TableCol[][], x: number, xIndex: number) => {
  const insertCols = new Map<string, TableCol>()
  let canInsertableRight = true
  gridTable.forEach((row: TableCol[]) => {
    const col = row[x]
    if (col) {
      const [originCol] = getCol(
        gridTable,
        (n: TableCol) => n.cell.key === col.cell.key && n.isReal
      )
      const { cell, path } = originCol
      const canInsertAtX =
        !row[x + 1] ||
        (col.isReal && (!col.cell.colspan || col.cell.colspan === 1)) ||
        path[xIndex] + (cell.colspan || 1) - 1 === x
      if (canInsertAtX) {
        insertCols.set(cell.key, originCol)
      } else {
        canInsertableRight = false
      }
    }
  })

  return { canInsertableRight, insertCols }
}

export const checkInsertLeft = (gridTable: TableCol[][], x: number, xIndex: number) => {
  const insertCols = new Map<string, TableCol>()
  let canInsertableLeft = true
  gridTable.forEach((row: TableCol[]) => {
    const col = row[x]
    if (col) {
      const [originCol] = getCol(
        gridTable,
        (n: TableCol) => n.cell.key === col.cell.key && n.isReal
      )
      const { path } = originCol
      const canInsertAtX = col.isReal || path[xIndex] === x
      if (canInsertAtX) {
        insertCols.set(col.cell.key, col)
      } else {
        canInsertableLeft = false
      }
    }
  })

  return { canInsertableLeft, insertCols }
}

export const canInsertColRight = (editor: CustomEditor) => {
  const result = { insertCols: new Map<string, TableCol>(), canInsertableRight: true }
  if (!editor.selection || !isTable(editor)) {
    return result
  }
  const { gridTable, xIndex } = getGridTable(editor)
  const insertPositionCol = getInsertPositionCol(editor)
  if (!insertPositionCol) {
    return result
  }
  const x = insertPositionCol.path[xIndex] + (insertPositionCol.cell.colspan || 1) - 1

  const { canInsertableRight, insertCols } = checkInsertRight(gridTable, x, xIndex)
  result.canInsertableRight = canInsertableRight
  result.insertCols = insertCols

  return result
}

export const canInsertColLeft = (editor: CustomEditor) => {
  const result = { insertCols: new Map<string, TableCol>(), canInsertableLeft: true }
  if (!editor.selection || !isTable(editor)) {
    return result
  }
  const { gridTable, xIndex } = getGridTable(editor)
  const insertPositionCol = getInsertPositionCol(editor)
  if (!insertPositionCol) {
    return result
  }
  const x = insertPositionCol.path[xIndex]

  const { canInsertableLeft, insertCols } = checkInsertLeft(gridTable, x, xIndex)
  result.canInsertableLeft = canInsertableLeft
  result.insertCols = insertCols

  return result
}

export const insertColRight = (editor: CustomEditor) => {
  const { insertCols, canInsertableRight } = canInsertColRight(editor)
  if (!canInsertableRight || !insertCols) {
    return
  }
  insertCols.forEach((col) => {
    const newCell = createCell({})
    Transforms.insertNodes(editor, newCell, {
      at: Path.next(col.originPath),
    })
  })
}

export const insertColLeft = (editor: CustomEditor) => {
  const { insertCols, canInsertableLeft } = canInsertColLeft(editor)
  if (!canInsertableLeft || !insertCols) {
    return
  }
  insertCols.forEach((col) => {
    const newCell = createCell({})
    Transforms.insertNodes(editor, newCell, {
      at: col.originPath,
    })
  })
}
